import { createAsyncThunk } from "@reduxjs/toolkit";

export const addToNmckGroup = createAsyncThunk("nmck/addToNmckGroup", async ({ groupId, nmckId }, { rejectWithValue, extra }) => {
	try {
		const { data } = await extra.apiNmck.addToGroup({
			group_id: groupId,
			nmck_id: nmckId,
		});

		if (!data) {
			throw new Error();
		}

		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
